import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { trackPageView } from '@/lib/analytics';

/**
 * Automatic page view tracking hook
 * 
 * This hook automatically tracks page views when the route changes.
 * Add this once at the App level.
 * 
 * Usage:
 * ```typescript
 * function App() {
 *   usePageTracking();
 *   return <YourApp />;
 * }
 * ```
 */
export function usePageTracking() {
  const [location] = useLocation();

  useEffect(() => {
    // Track page view on mount and route change
    trackPageView(location, document.title);
  }, [location]);
}
